// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"899":"c2a795f4","964":"352717c0"}[chunkId] + ".chunk.css");